import { type ComponentType, lazy, type LazyExoticComponent } from 'react';

type PropsOf<M, K extends keyof M> = M[K] extends ComponentType<infer P> ? P : never;

/**
 * Carrega uma página sob demanda a partir de um módulo com exportação nomeada,
 * preservando a tipagem das props. Cada rota vira um chunk próprio.
 */
export function lazyPage<M, K extends keyof M & string>(
  loader: () => Promise<M>,
  exportName: K,
): LazyExoticComponent<ComponentType<PropsOf<M, K>>> {
  return lazy(async () => {
    const mod = await loader();
    return { default: mod[exportName] as ComponentType<PropsOf<M, K>> };
  });
}
